import React from "react";

export default function Portfolio() {
  return (
    <div className="portfolio-page">
      <main className="main">
        <section id="portfolio" className="portfolio section">
          <div className="container section-title" data-aos="fade-up">
            <h2>Portfolio</h2>
            <p>
              Explore my full stack development and cybersecurity projects that
              demonstrate expertise in building secure, scalable web
              applications and implementing robust security solutions.
            </p>
          </div>

          <div className="container" data-aos="fade-up" data-aos-delay="100">
            {/* Removed filter tabs and isotope layout wrappers */}
            <div className="row gy-4">
              {/* Netlify Live Projects */}
              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/tour.webp"
                      alt="Tour For Sell Platform"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="https://liontracksafari.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portfolio-details-link"
                      >
                        <i className="bi bi-link"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>Lion track safari </h4>
                    <p>Tourism Booking Platform for lion track companies.</p>
                    <div className="portfolio-tags">
                      <span>Tourism websites</span>
                      <span>Newsletter Subscription</span>
                      <span>Live</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/hillu.webp"
                      alt="Elia Mahenge Portfolio"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="https://hilmaragotard.netlify.app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portfolio-details-link"
                      >
                        <i className="bi bi-link"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>Hilmara Portfolio</h4>
                    <p>Professional Portfolio Website</p>
                    <div className="portfolio-tags">
                      <span>React</span>
                      <span>Portfolio</span>
                      <span>Live</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/guru.webp"
                      alt="Guru Business Solutions"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="https://gurubusiness.netlify.app"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="portfolio-details-link"
                      >
                        <i className="bi bi-link"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>Guru Business</h4>
                    <p>Business Solutions Platform</p>
                    <div className="portfolio-tags">
                      <span>Business</span>
                      <span>Solutions</span>
                      <span>Live</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Technical Projects */}
              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/elearning.webp"
                      alt="E-Learning Platform"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="assets/img/portfolio/elearning.webp"
                        className="glightbox portfolio-lightbox"
                      >
                        <i className="bi bi-plus"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>Ekima Elearning platforms</h4>
                    <p>Full Stack Learning Platform</p>
                    <div className="portfolio-tags">
                      <span>JHipster</span>
                      <span>React</span>
                      <span>On Development</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/cyber.webp"
                      alt="Security Audit System"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="assets/img/portfolio/cyber.webp"
                        className="glightbox portfolio-lightbox"
                      >
                        <i className="bi bi-plus"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>Security Audit Platform</h4>
                    <p>Vulnerability Assessment</p>
                    <div className="portfolio-tags">
                      <span>Cybersecurity</span>
                      <span>Penetration Testing</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/restApi.webp"
                      alt="REST API System"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="assets/img/portfolio/restApi.webp"
                        className="glightbox portfolio-lightbox"
                      >
                        <i className="bi bi-plus"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>REST API System</h4>
                    <p>Microservices Architecture</p>
                    <div className="portfolio-tags">
                      <span>Spring Boot</span>
                      <span>REST API</span>
                      <span>Microservices</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/database.webp"
                      alt="Database Management System"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="assets/img/portfolio/database.webp"
                        className="glightbox portfolio-lightbox"
                      >
                        <i className="bi bi-plus"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>Database System</h4>
                    <p>MySQL Optimization</p>
                    <div className="portfolio-tags">
                      <span>MySQL</span>
                      <span>Database Design</span>
                      <span>Performance</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/bahati.webp"
                      alt="React Application"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="assets/img/portfolio/bahati.webp"
                        className="glightbox portfolio-lightbox"
                      >
                        <i className="bi bi-plus"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>React professional portfolio</h4>
                    <p>Frontend Development</p>
                    <div className="portfolio-tags">
                      <span>React</span>
                      <span>JavaScript</span>
                      <span>UI/UX</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="portfolio-card">
                  <div className="portfolio-img">
                    <img
                      src="assets/img/portfolio/network.webp"
                      alt="Network Security"
                      className="img-fluid"
                    />
                    <div className="portfolio-overlay">
                      <a
                        href="assets/img/portfolio/network.webp"
                        className="glightbox portfolio-lightbox"
                      >
                        <i className="bi bi-plus"></i>
                      </a>
                      <a href="#" className="portfolio-details-link">
                        <i className="bi bi-link"></i>
                      </a>
                    </div>
                  </div>
                  <div className="portfolio-info">
                    <h4>Network Security</h4>
                    <p>Intrusion Detection System</p>
                    <div className="portfolio-tags">
                      <span>Network Security</span>
                      <span>IDS/IPS</span>
                      <span>Monitoring</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="text-center mt-5" data-aos="fade-up" data-aos-delay="400">
              <a href="/contact" className="btn btn-primary">
                Start Your Project
              </a>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}